export const frForbiddenDepartments = ['Mayotte'];
